import "./ProfileSubpageHeader.scss";

const ProfileSubpageHeader = (props: {
  title: string;
  description: string;
}) => {
  const { title, description } = props;

  return (
    <div className="profile-subpage-header">
      <div className="title">{title}</div>
      <div className="description">{description}</div>
    </div>
  );
};

export default ProfileSubpageHeader;
